import React from "react";
import { Input, Form, DatePicker, Upload, Button } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { getLangList } from '@/lib/i18n';
import { currentTime, getMoment } from "@/lib/dateTime";
import { avatarUploadProps, normFile } from "@/lib/uploadFunction";
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form?: any;
  itemInfo: any;
  handleType: string;
}

class ModalInfo extends React.Component<props> {
  lostAndFoundT: any = getLangList("lostAndFound");

  componentDidMount() {
    const { form, itemInfo, handleType } = this.props;
    const {
      foundTime,
      foundItem,
      foundPlace,
    } = itemInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({
        foundTime: getMoment(foundTime),
        foundItem,
        foundPlace,
      });
    }
  }

  render() {
    const { form } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          foundTime: currentTime,
        }}
      >
        <Form.Item
          label={this.lostAndFoundT.DATE}
          name="foundTime"
          rules={[{ required: true }]}
        >
          <DatePicker />
        </Form.Item>

        <Form.Item
          label={this.lostAndFoundT.ITEM}
          name="foundItem"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={this.lostAndFoundT.PLACE}
          name="foundPlace"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={this.lostAndFoundT.PICTURE}
          name="itemImg"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload {...avatarUploadProps}>
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Form.Item>
      </Form >
    );
  }
}

export default ModalInfo;